module.exports = __webpack_public_path__ + "img/merge-qr.ec598b3d.png";